import { defineStore } from 'pinia';
import { useProductEditorStore } from '@/v2/modules/products/stores/product-editor/index';
import { marketplacesEnum } from '@/v2/utils/marketplaces';

export const useAmazonStore = defineStore('amazon', {
	state: () => ({
		data: {},
		variants: {},
	}),
	getters: {
		formValues(state) {
			const productEditorStore = useProductEditorStore();

			const formValues = {};

			productEditorStore.amazonLinkedMarketplaces.forEach((m) => {
				const linkedVariants = {};

				productEditorStore.data.variants.forEach((variant) => {
					const linkedVariant = this.data[m.id]?.linked_variants?.find(
						(el) => el.id === variant.id,
					);

					if (!linkedVariant) return;

					linkedVariants[variant.id] = {
						sku: linkedVariant.sku,
						asin: linkedVariant.asin,
						identifier_value: linkedVariant.asin,
						identifier_type: 'ASIN',
						marketplace_category_id: this.data[m.id]?.category?.id,
						marketplace_brand_id: this.data[m.id]?.brand?.id,
						extra_data: {},
					};
				});

				formValues[m.id] = {
					linked_product: {},
					linked_variant: linkedVariants,
				};
			});

			return formValues;
		},
	},
	actions: {
		async setData(marketplacesData) {
			const productEditorStore = useProductEditorStore();

			marketplacesData.forEach((amazon) => {
				const linkedProduct = amazon?.linked_product;
				const linkedVariants = amazon?.linked_variant;
				const variants = Object.values(linkedVariants || {}).map((el) => el[0]);

				const data = {
					category: variants[0]?.marketplace_category || null,
					brand: variants[0]?.marketplace_brand || null,
					linked_variants: variants.map((variant) => {
						const productVariant = productEditorStore.data.variants.find(
							(el) => el.id === variant.variant_id,
						);

						return {
							id: variant.variant_id,
							sku: variant.sku,
							asin: variant.identifier_value,
							fulfillment_channel: variant.fulfillment_channel || 'SELLER',
						};
					}),
				};

				this.variants[amazon.linked_marketplace_id] = variants;
				this.data[amazon.linked_marketplace_id] = data;
			});
		},
		async submit() {},
	},
});
